export const getRuntimeEnvironment = () =>
  ["www.iwoca.co.uk", "www.iwoca.de"].includes(window.location.hostname)
    ? "production"
    : "staging";
